module.exports = __webpack_public_path__ + "img/breenq_bg.5f950b1f.png";